import React from 'react';

import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';

import FollowUnFollowButton from 'src/components/ui/FollowUnFollowButton';
import CompanyProfilePlusButton from 'src/components/company/CompanyProfilePlusButton';
import ChatButton from 'src/components/ui/ChatButton';
import type { CompanyProfileQuery } from 'src/types/__generated__/graphql';
import useUser from 'src/hooks/useUser';

interface Props {
    company: CompanyProfileQuery['companyProfile'];
}

const CompanyHeaderCTAs: React.FC<Props> = ({ company }) => {
    const currentUser = useUser();
    const currentUserIsCompanyContactUser = company.contactUser?.id === currentUser?.id;
    return (
        <Box mt={2} data-target-id="companyHeader-showMore">
            <CardActions sx={{ p: 0 }}>
                <FollowUnFollowButton
                    company={company}
                    followButtonProps={{
                        variant: 'outlined',
                        'data-target-id': 'companyHeader-followUnfollowButton',
                    }}
                    refetchQueries={['CompanyProfile']}
                />
                {!currentUserIsCompanyContactUser && company.contactUser && (
                    <ChatButton
                        userId={company.contactUser.id as unknown as string}
                        data-target-id="companyHeader-chatButton"
                        variant="outlined"
                        sx={{ height: '2.5rem', pr: '0.75rem' }}
                    />
                )}
                <CompanyProfilePlusButton company={company} />
            </CardActions>
        </Box>
    );
};

export default CompanyHeaderCTAs;
